import React, { useState } from "react";
import { ArrowLeft, Star, CheckCircle } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

export default function Feedback() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const orderId = params.get("order") || "";

  const [rating, setRating] = useState(0);
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async () => {
    if (!rating) return alert("Please give a rating");

    if (!orderId) {
      alert("Order ID missing. Please open feedback from Track Order.");
      return;
    }

    const student = JSON.parse(localStorage.getItem("student"));
    if (!student) return alert("User not logged in");

    const body = {
      usn: student.usn,
      orderId,
      rating,
      message,
    };

    try {
    const res = await fetch("https://hostel-laundry-api.onrender.com/feedback/new", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const txt = await res.text();
      console.log("Backend Response:", txt);

      if (res.ok) setSubmitted(true);
      else alert("Failed to submit feedback");
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong");
    }
  };

  // SUCCESS UI
  if (submitted) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-white p-6 text-center">
        <CheckCircle className="w-16 h-16 text-neutral-900 mb-4" />
        <h1 className="text-2xl font-semibold text-neutral-900">
          Thank You for Your Feedback!
        </h1>
        <p className="text-neutral-500 text-sm mt-1">
          Your response helps us improve the service.
        </p>

        <button
          onClick={() => (window.location.href = "/student-dashboard")}
          className="mt-6 bg-neutral-900 text-white px-6 py-3 rounded-xl font-medium text-sm hover:bg-neutral-800 transition shadow-sm"
        >
          Go to Dashboard
        </button>
      </div>
    );
  }

  // MAIN FEEDBACK UI
  return (
    <div className="min-h-screen bg-white p-4 flex justify-center">
      <div className="w-full max-w-3xl space-y-5">

        {/* HEADER */}
        <header className="flex items-center justify-between bg-white/80 backdrop-blur-lg border border-neutral-200 rounded-xl px-4 py-3">
          <Link
            to="/track-order"
            className="p-2 rounded-full hover:bg-neutral-100 transition"
          >
            <ArrowLeft className="w-5 h-5 text-neutral-700" />
          </Link>

          <h1 className="text-base font-semibold text-neutral-900">Feedback</h1>

          <div className="w-5" />
        </header>

        {/* FEEDBACK CARD */}
        <div className="bg-white border border-neutral-200 rounded-2xl p-6">
          <h2 className="text-lg font-semibold text-neutral-900 mb-4">
            Rate Your Experience
          </h2>

          {/* STAR RATING — monochrome */}
          <div className="flex gap-2 mb-5">
            {[1, 2, 3, 4, 5].map((n) => (
              <Star
                key={n}
                onClick={() => setRating(n)}
                className={`w-8 h-8 cursor-pointer transition-all ${
                  n <= rating
                    ? "text-neutral-900 fill-neutral-900 scale-110"
                    : "text-neutral-300 hover:text-neutral-400"
                }`}
              />
            ))}
          </div>

          {/* MESSAGE BOX */}
          <label className="text-sm font-medium text-neutral-600">
            Additional Comments (Optional)
          </label>

          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Share your thoughts..."
            className="w-full mt-2 p-3 border border-neutral-200 bg-neutral-50 rounded-xl min-h-[100px] text-neutral-900 text-sm focus:ring-2 focus:ring-neutral-900 focus:bg-white outline-none transition-all"
          ></textarea>

          {/* SUBMIT BUTTON */}
          <button
            onClick={handleSubmit}
            className="w-full bg-neutral-900 text-white mt-5 py-3.5 rounded-xl font-semibold text-sm hover:bg-neutral-800 transition shadow-sm"
          >
            Submit Feedback
          </button>
        </div>
      </div>
    </div>
  );
}
